// Thin host wrapper — Qualifier Intel (Elite-tier). Gate per
// INTEGRATION_PATCH §7: desk_pro. Window/signals tables are deferred
// (PRD §10.2); the hook degrades to null/[] so the page renders its
// honest-empty + tier-locked teaser states.
import { useParams, useNavigate } from "react-router-dom";
import { useUserTier } from "../../auth/useUserTier.ts";
import { tierMeets } from "../../auth/tier-gates.ts";
import { useIntlAccaQualifier } from "../../intl-acca/useIntlAccaQualifier.ts";
import { QualifierIntelPage } from "./QualifierIntelPage.tsx";

export function IntlAccaQualifierRoute(): JSX.Element {
  const { windowId = "" } = useParams();
  const navigate = useNavigate();
  const { tierCode } = useUserTier();
  const vm = useIntlAccaQualifier(windowId);
  return (
    <QualifierIntelPage
      loading={vm.loading}
      error={vm.error}
      window={vm.window}
      signals={vm.signals}
      watchlist={vm.watchlist}
      hasEliteAccess={tierMeets(tierCode, "desk_pro")}
      onUpgrade={() => navigate("/pricing")}
    />
  );
}
